import { useMediaQuery, useTheme } from '@mui/material';
import { MainContainer, MainHeading } from './ProfessionalBackground.styles';
import ExperienceCard from './ExperienceCard';
import roles from '../../../copy/roles';

function ProfessionalBackground() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <MainContainer>
      <MainHeading variant="h2" component="h2">
        Career Chronicles
      </MainHeading>
      {roles.map(role => {
        return (
          <ExperienceCard key={role.role} role={role} isMobile={isMobile} />
        );
      })}
    </MainContainer>
  );
}

export default ProfessionalBackground;
